import { Box, Button, Container, Grid, Typography } from "@material-ui/core";
import { Translate as T } from "react-localize-redux";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useCheckoutContext } from "../../../context/useCheckoutContext";
import { useConfrontaValidationState } from "../state/useConfrontaValidationState";
import { ConfirmationDataModalEnum } from "../../../shared/constants/ConfirmationDataModalEnum";
import { configCardSections } from "../../../shared/constants/CheckoutContants";
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        body: (_a = {
                height: theme.spacing(33),
                padding: theme.spacing(1),
                paddingBottom: 0
            },
            _a[theme.breakpoints.down("xs")] = {
                height: "auto",
                minHeight: theme.spacing(33),
            },
            _a),
        button: {
            background: "rgba(2, 51, 101, 0.1)",
            borderRadius: "0 " + theme.spacing(1) + "px 0 0",
            fontSize: "12px",
        },
        cancelButton: {
            "& p": {
                fontSize: "14px",
                fontStyle: "normal",
                lineHeight: "140%",
            },
            alignContent: "center",
            alignItems: "center",
            borderRadius: "16px",
            marginLeft: "auto",
            marginRight: "auto",
        },
        continueButton: {
            borderRadius: "8px",
            fontSize: "16px",
            height: "40px",
        },
        img: {
            "& path": {
                fill: theme.typography.subtitle1.color,
            },
            fill: theme.typography.subtitle1.color,
            marginRight: theme.spacing(1),
            maxWidth: theme.spacing(3),
            verticalAlign: "middle",
        },
        subtitle: {
            "& span": {
                fontWeight: "bold",
            },
            alignItems: "center",
            color: "#293036",
            fontSize: "12px",
            fontWeight: "normal",
            margin: "0px auto",
            padding: theme.spacing(0, 1, 2, 1),
            width: "auto",
        },
        title: {
            alignItems: "center",
            color: "#6D7781",
            display: "flex",
            fontFamily: "IBM Plex Sans",
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: 300,
            justifyContent: "center",
            margin: "0px auto",
            padding: theme.spacing(1, 1, 2, 1),
        },
    });
});
export var ConfrontaStart = function () {
    var classes = useStyles();
    var handlers = useConfrontaValidationState().handlers;
    var _a = useCheckoutContext(), setCheckoutSection = _a.handlers.setCheckoutSection, amount = _a.amount;
    return (React.createElement(Box, { display: "flex", flexDirection: "column", alignItems: "center" },
        React.createElement(Container, { maxWidth: "lg" },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Box, { alignItems: "center", flexDirection: "row" },
                    React.createElement(Typography, { className: classes.title },
                        React.createElement(T, { id: "confirmationData.title" })))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Box, { padding: 1, alignItems: "center", flexDirection: "row" },
                    React.createElement(Typography, { className: classes.subtitle },
                        React.createElement(T, { id: "confirmationData.subtitle" }),
                        React.createElement("span", null,
                            React.createElement(T, { id: "confirmationData.subtitleBold" }))))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Box, { padding: 1, flexDirection: "row", alignItems: "center" },
                    React.createElement(Button, { variant: "text", className: classes.cancelButton, fullWidth: true, onClick: function () {
                            return setCheckoutSection(configCardSections.paymentMethods);
                        } },
                        React.createElement(Typography, null,
                            React.createElement(T, { id: "confirmationData.cancelButton" }))))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Box, { paddingTop: 2, alignItems: "center", flexDirection: "row" },
                    React.createElement(Button, { variant: "contained", color: "primary", fullWidth: true, className: classes.continueButton, onClick: function () {
                            return handlers.handleChangeView(ConfirmationDataModalEnum.DOCUMENT_VALIDATION);
                        } },
                        React.createElement(Typography, null,
                            React.createElement(T, { id: "confirmationData.subscribeButton" }),
                            " ",
                            amount.total,
                            " ",
                            amount.currency)))))));
};
export default ConfrontaStart;
